import Phaser from 'phaser';
import { GameScene, VIEW_H, VIEW_W } from './render/GameScene';
import { MenuScene } from './scenes/MenuScene';
import { HowToScene } from './scenes/HowToScene';
import { PALETTE } from './render/palette';

/**
 * Phaser は描画と入力だけを担当する。ゲームの状態は src/sim 以下の
 * 純粋な TypeScript が持ち、エンジンに依存しない。
 * Phase 1 でモノレポに分割するときも、この境界がそのまま残る。
 */
new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  width: VIEW_W,
  height: VIEW_H,
  backgroundColor: PALETTE.deep,
  scale: {
    mode: Phaser.Scale.FIT,
    // **中央寄せは CSS 側だけでやる。** Phaser の autoCenter は
    // 余白の半分を canvas の margin に足すので、`#app` の flex 中央寄せと
    // 二重にかかり、余白が大きいほど右下へずれる。
    // 端末では縦横比がほぼ一致して余白が無く、ずれが 0 なので気づけない。
    // 横長の枠に埋め込んで初めて出た（itch の iframe）。
    autoCenter: Phaser.Scale.NO_CENTER,
  },
  // Phaser 自身の音声機能は使わない。有効なままだと AudioContext が二重に作られる。
  // 音は src/audio が Web Audio で直接合成している。
  audio: { noAudio: true },
  // 物理エンジンは使わない。波と泳ぎは決定論シミュレーションが解いている。
  scene: [MenuScene, GameScene, HowToScene],
});
